import React, { useState, useEffect, useMemo } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  Button,
  FormHelperText,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  useTheme,
  TextField,
} from '@material-ui/core';
import DesktopTimePicker from '@material-ui/lab/DesktopTimePicker';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import { history, useLocation } from 'umi';
import { TextFieldCom, RadioFieldCom } from '@/components/FormType';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { OPT_DETAIL } from '@/constants.js';
import request from '@/utils/request.js';
import TitleML from './components/TitleML';
import MessageML from '@/components/MessageML/index';
import webStorage from '@/utils/storageManager';
import IndexStyles from './indexStyles';
import dayjs from 'dayjs';

export default () => {
  const DICTOBJ = webStorage.get('DICTOBJ');
  const { ECOMMERCE_EXECUTE_TYPE, ECOMMERCE_TYPE } = DICTOBJ || [];
  console.log({ ECOMMERCE_EXECUTE_TYPE, ECOMMERCE_TYPE });
  // const ACTIVITY_TYPE = [
  //   { value: '1', label: '入会关怀' }, "REGISTER"
  //   { value: '2', label: '积分增加关怀' }, "POINT_ADD"
  //   { value: '3', label: '积分减少关怀' }, "POINT_REDUCE"
  //   { value: '4', label: '升级鼓励' }, "LEVEL_ENCOURAGE"
  //   { value: '5', label: '升级关怀' }, "LEVEL_CHANGE"
  //   { value: '6', label: '生日祝福' },
  // ];
  const ACTIVITY_TYPE = ECOMMERCE_TYPE.map((item) => ({
    value: item.dictCode,
    label: item.nameZh,
  }));
  // const SEND_TYPE = [
  //   { value: '1', label: '立即发送' }, "AT_ONCE"
  //   { value: '2', label: '定时发送' },"ASSIGN"
  // ];
  const SEND_TYPE = ECOMMERCE_EXECUTE_TYPE.map((item) => ({
    value: item.dictCode,
    label: item.nameZh,
  }));
  const { handleSubmit, control, setValue, errors, getValues, watch, reset } =
    useForm({
      defaultValues: {
        type: 'REGISTER',
        sendType: 'AT_ONCE',
        sendTime: null,
      },
    });
  const theme = useTheme();
  const { query } = useLocation();
  const { opt, id } = query;
  const [openDialog, setOpenDialog] = useState();
  const [openSMS, setOpenSMS] = useState(false);
  const [openWechat, setOpenWechat] = useState(false);
  const [vxContent, setVxContent] = useState();
  const [smsContent, setSmsContent] = useState();
  const [msgId, setMsgId] = useState();
  const [wechatId, setWechatId] = useState();
  const [selectedNoticeChannels, setSelectedNoticeChannels] = useState([]);
  const [sceneMarketingDetail, setSceneMarketingDetail] = useState();

  // 这里没有默认展示
  const [msgChecked, setMsgChecked] = useState(false);
  const [vxChecked, setVxChecked] = useState(false);
  console.log({
    vxContent,
    smsContent,
    msgId,
    wechatId,
    selectedNoticeChannels,
    sceneMarketingDetail,
  });
  //模板消息
  const [noticeChannels, setNoticeChannels] = useState([
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '2',
    },
    {
      checked: false,
      msgId: '',
      msgContent: '',
      type: '1',
    },
  ]);

  useEffect(() => {
    if (!id) {
      return false;
    }
    request('/activity/querySceneDetail', {
      method: 'POST',
      data: {
        id,
      },
    })
      .then((res) => {
        const data = res.data;

        const title = data.title || null;
        const type = data.ecommerceData[0].sceneType || null;
        const point = data.ecommerceData[0].point || null;
        const sendType = data.ecommerceData[0].executeType || null;
        const sendTime = data.ecommerceData?.[0]?.noticeTime
          ? dayjs().format('YYYY-MM-DD') +
            ' ' +
            data.ecommerceData?.[0]?.noticeTime
          : null;

        setSelectedNoticeChannels(data.ecommerceData[0].noticeChannels);
        setSceneMarketingDetail(data.ecommerceData[0]);
        reset({
          title,
          type,
          point,
          sendType,
          sendTime,
        });
        setValue('title', title);
      })
      .catch();
  }, [id]);
  //关于编辑或预览初始给模板消息赋值
  useEffect(() => {
    if (sceneMarketingDetail?.noticeChannels) {
      const receiveNoticeChannels = sceneMarketingDetail?.noticeChannels;
      const wechatInfo = receiveNoticeChannels.filter((i) => i.type === '2')[0];
      // console.log('wechatInfo', wechatInfo);
      const msgInfo = receiveNoticeChannels.filter((i) => i.type === '1')[0];
      const editNoticeChannels = receiveNoticeChannels.map((item) => {
        return { checked: true, ...item };
      });
      // let array = [];
      const newNoticeChannels = noticeChannels?.map((currentValue) => {
        let obj;
        let type = currentValue.type;
        const channel = editNoticeChannels.find((i) => i.type === type);
        if (channel) {
          obj = channel;
        } else {
          obj = currentValue;
        }
        return obj;
      });
      setNoticeChannels(newNoticeChannels);
      if (wechatInfo) {
        // console.log('wechatInfo', wechatInfo);
        setVxChecked(true);
        setVxContent(wechatInfo?.msgContent);
        if (wechatInfo.msgId) {
          setWechatId(Number(wechatInfo?.msgId));
          // console.log('Number(wechatInfo?.msgId)', Number(wechatInfo?.msgId));
        }
      }
      if (msgInfo) {
        // console.log('msgInfo', msgInfo);
        setMsgChecked(true);
        setSmsContent(msgInfo?.msgContent);
        if (msgInfo.msgId) {
          setMsgId(Number(msgInfo?.msgId));
          // console.log('Number(wechatInfo?.msgId)', Number(msgInfo?.msgId));
        }
      }
    }
  }, [sceneMarketingDetail]);
  let wechatInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '2',
  );
  let msgInfoItem = sceneMarketingDetail?.noticeChannels?.filter(
    (i) => i.type === '1',
  );

  console.log({
    vxContent,
    smsContent,
    msgId,
    wechatId,
    selectedNoticeChannels,
    sceneMarketingDetail,
    wechatInfoItem,
    msgInfoItem,
  });
  //拿到最新的值
  const handleSelectChange = (type, changes) => {
    // console.log('changes', changes);
    // console.log('type', type);

    let data = noticeChannels.concat();
    data.map((channel) => {
      if (channel.type === type.toString()) {
        channel.checked = changes.checked;
        channel.msgContent = changes.content;
        channel.msgId = changes.id;
      }
    });
    // console.log('data', data);
    setSelectedNoticeChannels(data);
  };

  const handSubmitSuccess = (data) => {
    console.log('data', data);
    console.log('selectedNoticeChannels', selectedNoticeChannels);
    const title = data.title || null;
    const sceneType = data.type || null;
    const point = data.point || null;
    const sendType = data.sendType || null;
    const noticeTime = data.sendTime
      ? dayjs(data.sendTime).format('HH:mm:00')
      : null;
    const newNoticeChannels = selectedNoticeChannels.filter(
      (item) => item.checked,
    );
    const values = {
      id,
      title,
      type: 'ECOMMERCE_ACTIVITY',
      noticeType: 'NOTICE_ONE',
      dateType: 'FIXED_TIME',
      ecommerceData: [
        {
          sceneType,
          point,
          executeType: sendType,
          noticeTime,
          noticeChannels: newNoticeChannels,
        },
      ],
    };
    let url = id ? '/activity/scene/update' : '/activity/scene/add';
    request(url, {
      method: 'POST',
      data: values,
    })
      .then(() => {
        window.message.toast({
          type: 'success',
          message: '保存成功',
          title: '保存成功',
        });
        history.goBack();
      })
      .catch();
  };

  const handleCallback = () => {
    setSelectedNoticeChannels([]);
    setVxContent();
    setSmsContent();
    setWechatId();
    setMsgId();
    setMsgChecked(false);
    setVxChecked(false);
    setValue('point', '');
    setValue('sendType', 'AT_ONCE');
    setValue('sendTime', null);
    setSceneMarketingDetail();
  };

  const watchType = watch('type');
  const watchSendType = watch('sendType');
  const watchSendTime = watch('sendTime');

  const initTips = useMemo(() => {
    if (watchType === 'POINT_ADD') {
      return '当会员积分生效，且积分值大于等于';
    } else if (watchType === 'POINT_REDUCE') {
      return '当会员积分减少，且积分值大于等于';
    } else if (watchType === 'LEVEL_ENCOURAGE') {
      return '当会员距离下一等级升级需要消耗金额小于';
    }
  }, [watchType]);
  console.log('watchType', watchType);
  return (
    <IndexStyles theme={theme}>
      <form onSubmit={handleSubmit(handSubmitSuccess)}>
        <Box
          borderRadius="12px"
          bgcolor="background.paper"
          height="100%"
          pt={3}
          pr={4}
          pb={4}
          pl={4}
        >
          <TitleML title="基础设置" fontSize="19px" p="0 0 32px 0" />
          <Box display="flex" flexDirection="column" gap="32px">
            <Box width="400px">
              <TextFieldCom
                initLabel={false} //自定义的label是否显示
                showLabel={true} //是否需要显示label
                placeholder="请输入"
                disabled={opt === OPT_DETAIL}
                helperText="" //用于校验的提醒文字
                name="title"
                label="活动名称" //label
                control={control}
                errors={errors}
                setValue={setValue}
                getValues={getValues}
                showError={true} //false输入框捕获到错误不展示错误样式，默认true
                rules={{
                  required: true, //是否是必填项true 必填 false 非必填
                  maxLength: 20,
                }}
              />
            </Box>
            <TitleML title="通知配置" fontSize="19px" p="32px 0 0 0" />
            <RadioFieldCom
              errors={errors}
              control={control}
              getValues={getValues}
              setValue={setValue}
              disabled={opt === OPT_DETAIL}
              initLabel="initLabel"
              label="内容类型"
              name="type"
              typeList={ACTIVITY_TYPE}
              callback={handleCallback}
            />
            <div
              style={{
                display: [
                  'POINT_ADD',
                  'POINT_REDUCE',
                  'LEVEL_ENCOURAGE',
                ].includes(watchType)
                  ? 'block'
                  : 'none',
              }}
            >
              <Box display="flex" mb={2}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#212100',
                  }}
                >
                  <span className="label-require">*</span>
                  {initTips}
                </Box>

                <TextFieldCom
                  style={{ width: '80px' }}
                  autoFocus={false} //If true, the input element is focused during the first mount.
                  initLabel={false} //自定义的label是否显示
                  showLabel={false} //是否需要显示label
                  // placeholder="0"
                  disabled={opt === OPT_DETAIL}
                  helperText="" //用于校验的提醒文字
                  initErrorText="必填项"
                  name="point"
                  label="" //label
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                  isNumber={true}
                  umber={true} //true 只能输入正数，false可以输入负数
                  decimalMark={2}
                  isParseInt={false} //true 只能输入整数，false可以输入小数
                  rules={{
                    required: watchType === 'POINT_ADD', //是否是必填项true 必填 false 非必填
                  }}
                />

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#212100',
                    marginLeft: '2px',
                  }}
                >
                  时，触发关怀短信
                </Box>
              </Box>
              <RadioFieldCom
                errors={errors}
                control={control}
                getValues={getValues}
                setValue={setValue}
                disabled={opt === OPT_DETAIL}
                initLabel="initLabel"
                label="发送设置"
                name="sendType"
                typeList={SEND_TYPE}
              />
              <div
                style={{
                  marginTop: '8px',
                  display: watchSendType === 'ASSIGN' ? 'block' : 'none',
                }}
              >
                <Controller
                  control={control}
                  name="sendTime"
                  render={(pr) => {
                    return (
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopTimePicker
                          disabled={opt === OPT_DETAIL}
                          label={
                            <>
                              <span style={{ color: '#f44336' }}>*</span>
                              发送时间
                            </>
                          }
                          inputFormat="HH:mm:ss" //时间格式化
                          value={pr.value}
                          onChange={(newValue) => {
                            return pr.onChange(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              sx={{ width: '168px' }}
                              variant="standard"
                              {...params}
                            />
                          )}
                        />
                      </LocalizationProvider>
                    );
                  }}
                  rules={{
                    validate: {
                      required: () => {
                        if (
                          [
                            'POINT_ADD',
                            'POINT_REDUCE',
                            'LEVEL_ENCOURAGE',
                            'LEVEL_CHANGE',
                          ].includes(watchType) &&
                          watchSendType === 'ASSIGN' &&
                          !watchSendTime
                        ) {
                          return false;
                        }
                        return true;
                      },
                    },
                  }}
                />
                {errors.sendTime && (
                  <FormHelperText
                    error={errors.sendTime}
                    sx={{ fontSize: '12px' }}
                  >
                    发送时间必选
                  </FormHelperText>
                )}
              </div>
            </div>
            <TitleML title="通知配置" fontSize="19px" p="32px 0 0 0" />
            <div style={{ display: 'flex', gap: '48px' }}>
              {['REGISTER'].includes(watchType) && (
                <div>
                  {['REGISTER'].includes(watchType) && (
                    <div
                      style={{
                        color: '#212100',
                        fontSize: '16px',
                        marginBottom: '8px',
                      }}
                    >
                      小程序渠道
                    </div>
                  )}
                  <div
                    style={
                      ['REGISTER'].includes(watchType)
                        ? {
                            display: 'inline-block',
                            border: '1px dashed #ccc',
                            padding: '12px 56px 15px 16px',
                            borderRadius: '3px',
                          }
                        : {}
                    }
                  >
                    <MessageML
                      opt={opt}
                      content={vxContent}
                      setChecked={setVxChecked}
                      checked={vxChecked}
                      setContent={setVxContent}
                      type={2}
                      info={wechatInfoItem}
                      handleSelectChange={handleSelectChange}
                      selectedId={wechatId}
                      setSelectedId={setWechatId}
                      open={openWechat}
                      setOpen={setOpenWechat}
                    ></MessageML>
                  </div>
                </div>
              )}
              <div>
                {['REGISTER'].includes(watchType) && (
                  <div
                    style={{
                      color: '#212100',
                      fontSize: '16px',
                      marginBottom: '8px',
                    }}
                  >
                    其他渠道
                  </div>
                )}
                <div
                  style={
                    ['REGISTER'].includes(watchType)
                      ? {
                          display: 'inline-block',
                          border: '1px dashed #ccc',
                          padding: '12px 56px 15px 16px',
                          borderRadius: '3px',
                        }
                      : {}
                  }
                >
                  <MessageML
                    opt={opt}
                    checked={msgChecked}
                    setChecked={setMsgChecked}
                    content={smsContent}
                    setContent={setSmsContent}
                    type={1}
                    info={msgInfoItem}
                    handleSelectChange={handleSelectChange}
                    selectedId={msgId}
                    setSelectedId={setMsgId}
                    open={openSMS}
                    setOpen={setOpenSMS}
                  ></MessageML>
                </div>
              </div>
            </div>
          </Box>
        </Box>

        <Box
          borderRadius="12px"
          bgcolor="background.paper"
          padding="24px 0 24px 31px"
          display="flex"
          gap="0 24px"
        >
          {opt !== OPT_DETAIL && (
            <Button
              variant="contained"
              className="coupons-setting-button"
              startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
              type="submit"
            >
              完成
            </Button>
          )}
          <Button
            variant="contained"
            className="coupons-setting-button"
            color="secondary"
            onClick={() => {
              setOpenDialog(true);
            }}
            startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
          >
            退出
          </Button>
        </Box>
      </form>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {opt !== OPT_DETAIL
              ? '退出后将不保存设置内容，确定要退出吗？'
              : '确定要退出吗？'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </IndexStyles>
  );
};
